import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'

import {
    Form,
    Input,
    Button,
    ValidacaoYup,
    CNPJ,
    CPF,
    Celular,
} from './../../components/Form'
import { mensagemErro, mensagemSucesso } from './../../components/Layout'

import { cpf, cnpj } from 'cpf-cnpj-validator'

import { useAuth } from './../../context/Auth'
import { useLayout } from './../../context/Layout'
import { useTheme } from './../../context/Theme'

import api from './../../api'
import './style.scss'

import ReCAPTCHA from "react-google-recaptcha";

function Cadastro() {
    const location = useLocation()
    const userAuth = useAuth()

    const [load, setLoad] = useState(false)
    const [validacao, setValidacao] = useState('')
    const [cpfCnpj, setCpfCnpj] = useState('cnpj')
    const [user, setUser] = useState(null)

    const { isScreenLogin } = useLayout()
    const { theme } = useTheme()
    const history = useHistory()

    const recaptchaRef = React.createRef();

    const validaCampos = {
        nome: ValidacaoYup.string().min(3).max(200).required(),
        email: ValidacaoYup.string().email().required(),
        celular: ValidacaoYup.string().required(),
    }

    const validaGoogleCampos = {
        celular: ValidacaoYup.string().required(),
    }

    useEffect(() => {
        isScreenLogin(true)
        return () => isScreenLogin(false)
    }, [isScreenLogin])

    useEffect(() => {
        setUser(location.state?.googleUser)
    }, [location, history])

    async function onCadastro(data) {

        recaptchaRef.current.execute()

        try {

            const newCel = data.celular.replace(/\D/g, "");
            const cnpjcpfValid = data.cnpjcpf.replace(/\D/g, "");

            if (newCel.length !== 11) {
                mensagemErro('Informe um número de celular válido')
                return
            }

            if (cpfCnpj === 'cpf') {
                if (!cpf.isValid(cnpjcpfValid)) {
                    mensagemErro('Informe um CPF válido')
                    return
                }
            }
            else {
                if (!cnpj.isValid(cnpjcpfValid)) {
                    mensagemErro('Informe um CNPJ válido')
                    return
                }
            }

            setLoad(true)
            const { cnpjcpf, nome, celular, email } = data

            const resp = await api.post('login/cadastro', {
                cnpjcpf,
                nome: user?.nome ?? nome,
                celular,
                email: user?.email ?? email,
                google: user?.id
            })

            if (resp.data.type === 0) {
                if (user?.id) {

                    api.defaults.headers.Authorization = `Bearer ${user.token}`

                    userAuth.setUser({
                        id: user.id,
                        refresh: user.refresh || user.id,
                        nome: user.nome,
                        email: user.email,
                        avatar: user.avatar,
                        token: user.token,
                        finished: user
                    })

                    history.push('/dash')
                } else {

                    mensagemSucesso('Cadastro realizado com sucesso, por favor valide no seu e-mail')
                    history.push('codigo', { email: email })
                }
            }
            else if (resp.data.type === 1) {
                setValidacao(resp.data.mensagem)
            }

            setLoad(false)

        } catch (error) {
            setLoad(false)
            mensagemErro('Ops, parece que algo não saiu como esperado, tente novamente mais tarde!')
        }
    }

    const formUser = () => (
        <Form onSubmit={onCadastro} className="auth-form" validacao={user ? validaGoogleCampos : validaCampos}>
            <div className='cadastro--header'>
                <h1 className="cadastro-title">{!user ? "Cadastro" : "Finalizar cadastro"}</h1>
                <p className="cadastro-subtitle">Crie seu cadastro grátis e já comece a usar o Ambientar agora mesmo!</p>
            </div>

            <div className="type-selector-wrapper">
                <label className="field-label">Tipo de Cadastro</label>
                <div className="escolheCnpjCpf">
                    <div onClick={() => setCpfCnpj('cnpj')} className={`type-option ${cpfCnpj === 'cnpj' ? 'active' : ''}`}>CNPJ</div>
                    <div onClick={() => setCpfCnpj('cpf')} className={`type-option ${cpfCnpj === 'cpf' ? 'active' : ''}`}>CPF</div>
                </div>
            </div>

            {
                cpfCnpj === 'cpf' ?
                    <CPF name='cnpjcpf' titulo='CPF' placeholder='000.000.000-00' /> :
                    <CNPJ name='cnpjcpf' titulo='CNPJ' placeholder='00.000.000/0000-00' />
            }

            {
                !user && (
                    <>
                        <Input name='nome' titulo='Nome' placeholder='Digite seu nome completo' maxLength={255} />
                        <Input name='email' titulo='E-mail' placeholder='Digite seu melhor e-mail' maxLength={255} />
                    </>
                )
            }

            <Celular name='celular' titulo='Celular' placeholder='(00) 0 0000-0000' />

            <div className="submit-container">
                <Button load={load} name={!user ? 'Cadastrar' : 'Finalizar'} icon={<i className="fas fa-sign-in-alt"></i>} />
                {validacao && <div className="validaRetorno">{validacao}</div>}
            </div>

            <ReCAPTCHA
                ref={recaptchaRef}
                size='invisible'
                sitekey="6LeEskMeAAAAAKx_X9fXZ8pJSQ2F4T4pkR5x91m9"
                onChange={() => { }}
            />
        </Form>
    )

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <img src={theme === 'dark' ? "/assets/images/logo/logobranca.svg" : "/assets/images/logo/logo.svg"} alt="Ambientar Logo" className="login-logo" />
                    <p className='subtit'>GERENCIADOR DE LICENÇAS E CONDICIONANTES</p>
                </div>

                <div className="login-card">
                    <div className="login-form-wrapper">
                        {formUser()}
                    </div>
                </div>

                <div className="login-footer">
                    <p>Já tem uma conta? <Link to='/'>Fazer Login</Link></p>
                </div>
            </div>
        </div>
    )
}

export default Cadastro